import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import arrowDownIcon from "../../../assets/img/order-details/arrow-down.svg";
import arrowUpIcon from "../../../assets/img/order-details/arrow-up.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/img/order-details/settings.svg";
import plusIcon from "../../../assets/img/order-details/plus.svg";
import { ReactComponent as EditIcon } from "../../../assets/img/order-details/edit.svg";
import DropDownIcon from "../../../assets/img/order-details/drop-down.png";
import "./index.scss";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import { CONTACTS_ENUM } from "Constants/contacts";
import { useHistory } from "react-router-dom";
import { useMemo } from "react";
import { fetchProjects, updateProject } from "Redux/middlwares/project";
import { useTranslation } from "react-i18next";
import { Overlay, Tooltip } from "react-bootstrap";
import { DebounceInput } from "react-debounce-input";
import { getSupplierCustomers } from "Services/supplier-customers";

const toolTips = {
  ADD_NEW_PROJECT: 1,
  USER_SETTINGS: 2,
  COMPANY_SETTINGS: 3,
  EDIT_PROJECT: 4,
  EDIT_PROJECT1: 5,
};
const SupplierInformationColumn = ({
  title,
  rows,
  editing = false,
  saving = false,
  onEdit,
  onSave,
}) => (
  <div className="supplier-information-column">
    <div className="supplier-information-title">
      <strong>{title}</strong>

      <button
        type="button"
        className="supplier-information-edit"
        disabled={saving}
        onClick={editing ? onSave : onEdit}
      >
        {editing ? (
          <span className="supplier-information-check" aria-hidden="true">
            ✓
          </span>
        ) : (
          <EditIcon aria-hidden="true" />
        )}
      </button>
    </div>

    {rows.map(({ label, value, onChange, type = "text" }, index) => (
      <div className="supplier-information-row" key={`${label}-${index}`}>
        <span>{label}</span>

        {editing ? (
          <input
            type={type}
            value={value || ""}
            disabled={saving}
            onChange={(event) => onChange?.(event.target.value)}
          />
        ) : (
          <strong>{value || "-"}</strong>
        )}
      </div>
    ))}
  </div>
);

const OrderDetails = ({
  isSupplier,
  onSupplierCustomerModalOpen,
  onCreateUserModalOpen,
  onNewBusinessModalOpen,
  onCompanySelectionModalOpen,
  onProjectModalOpen,
  activeBusiness,
  setActiveBusiness,
  handleEditBusiness,
  activeProject,
  setActiveProject,
  handleEditProject,
  order,
  setOrder,
  setErrorText,
  edit,
  currentCompany,
  setCurrentCompany,
  setShowDetails,
  showDetails,
}) => {
  const { t } = useTranslation(["newOrder", "common", "myOrder"]);
  const dispatch = useAppDispatch();
  // const [showDetails, setShowDetails] = useState(false);
  const [siteManager, setSiteManager] = useState();
  const [toolTipShow, setToolTipShow] = useState();
  const [editingSection, setEditingSection] = useState(null);
  const [projectDraft, setProjectDraft] = useState({});
  const [savingSection, setSavingSection] = useState(false);
  const [supplierCustomers, setSupplierCustomers] = useState([]);

  const [supplierCustomersLoading, setSupplierCustomersLoading] =
    useState(false);
  const userData = useAppSelector((state) => state.user.userData);
  const userProjects = useAppSelector((state) => state.project.userProjects);
  const rightToLeft = useAppSelector((state) => state.root.rightToLeft);
  const router = useHistory();

  const projAdd = useRef();
  const companySet = useRef();
  const edit1 = useRef();
  const edit2 = useRef();
  const userSet = useRef();

  const startSectionEditing = (section) => {
    setProjectDraft({
      ...activeProject,
      contacts: (activeProject.contacts || []).map((contact) => ({
        ...contact,
      })),
    });

    setEditingSection(section);
  };

  const handleProjectFieldChange = (field, value) => {
    setProjectDraft((previous) => ({
      ...previous,
      [field]: value,
    }));
  };

  const getDraftContact = (role, occurrence = 0) => {
    const contacts = (projectDraft.contacts || []).filter(
      (contact) => contact.role === role,
    );

    return contacts[occurrence];
  };

  const handleContactFieldChange = (role, occurrence, field, value) => {
    setProjectDraft((previous) => {
      const contacts = (previous.contacts || []).map((contact) => ({
        ...contact,
      }));

      const matchingIndexes = contacts.reduce((indexes, contact, index) => {
        if (contact.role === role) {
          indexes.push(index);
        }

        return indexes;
      }, []);

      let contactIndex = matchingIndexes[occurrence];

      if (contactIndex === undefined) {
        contacts.push({
          user: userData.id,
          role,
          full_name: "",
          phone: "",
        });

        contactIndex = contacts.length - 1;
      }

      contacts[contactIndex] = {
        ...contacts[contactIndex],
        [field]: value,
      };

      return {
        ...previous,
        contacts,
      };
    });
  };

  useEffect(() => {
    setEditingSection(null);
    setProjectDraft({});
  }, [activeProject.id]);

  const saveSectionChanges = () => {
    if (!activeProject.id || savingSection) {
      return;
    }

    setSavingSection(true);

    const data = {
      ...projectDraft,
      user: userData.id,
      contacts: (projectDraft.contacts || []).filter(
        (contact) => contact.full_name?.trim() || contact.phone?.trim(),
      ),
    };

    dispatch(
      updateProject(
        activeProject.id,
        data,
        (updated, updatedProject, updateError) => {
          setSavingSection(false);

          console.log("PROJECT UPDATE RESULT:", {
            updated,
            updatedProject,
            updateError,
          });

          if (!updated) {
            return;
          }

          setActiveProject(updatedProject || data);
          setEditingSection(null);
        },
      ),
    );
  };



  useEffect(() => {
    setSiteManager();
    if (activeProject.contacts) {
      const manager = activeProject.contacts.find(
        (item) => item.role === CONTACTS_ENUM.SITE_MANAGER,
      );
      if (manager) {
        setSiteManager(manager);
      }
    }
  }, [activeProject]);

  const siteMans = useMemo(() => {
    if (activeProject && activeProject.contacts) {
      const _siteMans = activeProject.contacts.filter(
        (item) => item.role === CONTACTS_ENUM.SITE_MAN,
      );
      if (_siteMans.length > 0) {
        return {
          siteMan1: _siteMans[0].full_name + "  " + _siteMans[0].phone,
          siteMan2:
            _siteMans.length === 2
              ? _siteMans[1].full_name + "  " + _siteMans[1].phone
              : "",
        };
      }
    }
    return {
      siteMan1: "",
      siteMan2: "",
    };
  }, [activeProject]);

  useEffect(() => {
    if (userData && userProjects.length === 0) {
      dispatch(fetchProjects());
    }
  }, [userData, userProjects.length, dispatch]);

  useEffect(() => {
    if (userProjects.length === 0) {
      return;
    }

    if (isSupplier && !edit) {
      return;
    }

    setActiveProject((currentProject) => {
      if (!currentProject?.id) {
        return userProjects[0];
      }

      return (
        userProjects.find(
          (project) => project.id === currentProject.id,
        ) || userProjects[0]
      );
    });
  }, [
    userProjects,
    setActiveProject,
    isSupplier,
    edit,
  ]);

  useEffect(() => {
    if (!isSupplier) {
      return;
    }

    const loadSupplierCustomers = async () => {
      try {
        setSupplierCustomersLoading(true);

        const response = await getSupplierCustomers("", "");

        setSupplierCustomers(response?.data?.results || response?.data || []);
      } catch (error) {
        console.error("Failed to load supplier customers", error);

        setSupplierCustomers([]);
      } finally {
        setSupplierCustomersLoading(false);
      }
    };

    loadSupplierCustomers();
  }, [isSupplier]);

  useEffect(() => {
  if (!isSupplier || supplierCustomers.length === 0) {
    return;
  }

  const supplierCustomerId =
    typeof order.supplier_customer === "object"
      ? order.supplier_customer?.id
      : Number(order.supplier_customer);

  if (
    !supplierCustomerId ||
    typeof order.supplier_customer === "object"
  ) {
    return;
  }

  const customer = supplierCustomers.find(
    (item) => Number(item.id) === Number(supplierCustomerId),
  );

  if (!customer) {
    return;
  }

  setOrder((previous) => ({
    ...previous,
    supplier_customer: customer,
  }));
}, [
  isSupplier,
  supplierCustomers,
  order.supplier_customer,
  setOrder,
]);

  const selectedSupplierCustomerId =
    typeof order.supplier_customer === "object"
      ? order.supplier_customer?.id
      : order.supplier_customer;

  const selectedSupplierCustomer =
    typeof order.supplier_customer === "object"
      ? order.supplier_customer
      : supplierCustomers.find(
  (customer) =>
    Number(customer.id) === Number(selectedSupplierCustomerId),
) || null;

  const primarySupplierContact =
    selectedSupplierCustomer?.contacts?.find((contact) => contact.is_primary) ||
    selectedSupplierCustomer?.contacts?.[0] ||
    null;

  const selectedSiteManager = activeProject?.contacts?.find(
    (contact) => contact.role === CONTACTS_ENUM.SITE_MANAGER,
  );

  const selectedSiteContact = activeProject?.contacts?.find(
    (contact) => contact.role === CONTACTS_ENUM.SITE_MAN,
  );

  useEffect(() => {
    return () => {
      setActiveProject({});
    };
  }, [setActiveProject]);

  if (isSupplier) {
    return (
      <section
        id="order-details-new-section"
        className="supplier-new-order-details"
        dir={rightToLeft ? "rtl" : "ltr"}
      >
        <div className="container p-0">
          <div className="supplier-order-detail-header">
            <strong>
              {t("Order Details", {
                ns: "newOrder",
              })}
            </strong>

            <span>
              {t("Create Date", {
                ns: "newOrder",
              })}{" "}
              {format(new Date(order.created), "dd/MM/yyyy")}
              <i>|</i>
              {t("Last update", {
                ns: "newOrder",
              })}{" "}
              {format(new Date(order.updated), "dd/MM/yyyy")}
              <i>|</i>
              {t("Order number", {
                ns: "newOrder",
              })}{" "}
              <span dir="ltr">{order.order_no || "-"}</span>
            </span>
          </div>

          <div className="supplier-order-detail-body">
            <div className="supplier-order-fields">
              <div className="supplier-order-field">
                <label>
                  {t("supplier customer", {
                    ns: "myOrder",
                  })}
                </label>

                <div className="supplier-order-field-row">
                  <select
                    value={selectedSupplierCustomerId || ""}
                    disabled={supplierCustomersLoading}
                    onChange={(event) => {
                      const customerId = event.target.value
                        ? Number(event.target.value)
                        : null;

                      const selectedCustomer =
                        supplierCustomers.find(
                          (customer) => Number(customer.id) === customerId,
                        ) || null;

                      setOrder((previous) => ({
                        ...previous,
                        supplier_customer: selectedCustomer,
                      }));
                    }}
                  >
                    <option value="">
                      {supplierCustomersLoading
                        ? t("Loading", {
                            ns: "common",
                          })
                        : t("select customer", {
                            ns: "myOrder",
                          })}
                    </option>

                    {supplierCustomers.map((customer) => (
                      <option key={customer.id} value={customer.id}>
                        {customer.name}
                      </option>
                    ))}
                  </select>

                  <button
                    type="button"
                    className="supplier-order-plus"
                    onClick={() => onSupplierCustomerModalOpen(null)}
                    title={t("add customer modal title", {
                      ns: "myOrder",
                    })}
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="supplier-order-field">
                <label>
                  {t("Order name", {
                    ns: "newOrder",
                  })}
                </label>

                <DebounceInput
                  type="text"
                  debounceTimeout={1000}
                  value={order.name || ""}
                  onChange={({ target }) => {
                    if (!edit) {
                      localStorage.setItem("order_name", target.value);
                    }

                    setOrder((previous) => ({
                      ...previous,
                      name: target.value,
                    }));
                  }}
                />
              </div>

              <div className="supplier-order-field">
                <label>
                  {t("Project Name", {
                    ns: "newOrder",
                  })}
                </label>

                <div className="supplier-order-field-row">
                  <select
                    value={activeProject?.id || ""}
                    onChange={({ target }) => {
                      const selectedProject = userProjects.find(
                        (project) => project.id === Number(target.value),
                      );

                      if (!selectedProject) return;

                      setActiveProject(selectedProject);

                      setOrder((previous) => ({
                        ...previous,
                        project: selectedProject.id,
                      }));
                    }}
                  >
                    <option value="">
                      {t("select site", {
                        ns: "myOrder",
                      })}
                    </option>

                    {userProjects.map((project) => (
                      <option key={project.id} value={project.id}>
                        {project.name}
                      </option>
                    ))}
                  </select>

                  <button
                    type="button"
                    className="supplier-order-plus"
                    onClick={onProjectModalOpen}
                    title={t("add new project", {
                      ns: "newOrder",
                    })}
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="supplier-order-field supplier-order-date">
                <label>
                  {t("Delivery date", {
                    ns: "newOrder",
                  })}
                </label>

                <input
                  type="date"
                  value={order.delivery_date || ""}
                  min={format(new Date(), "yyyy-MM-dd")}
                  onChange={({ target }) => {
                    setOrder((previous) => ({
                      ...previous,
                      delivery_date: target.value,
                    }));

                    localStorage.setItem("delivery_date", target.value);
                  }}
                />
              </div>
            </div>

            {showDetails && (
              <div className="supplier-order-information">
                <SupplierInformationColumn
                  title={t("customer details", {
                    ns: "myOrder",
                  })}
                  onEdit={() => {
                    if (!selectedSupplierCustomer?.id) {
                      return;
                    }
                    onSupplierCustomerModalOpen(selectedSupplierCustomer);
                  }}
                  rows={[
                    {
                      label: t("supplier customer name", {
                        ns: "myOrder",
                      }),
                      value: selectedSupplierCustomer?.name || "-",
                    },
                    {
                      label: t("supplier business number", {
                        ns: "myOrder",
                      }),
                      value: selectedSupplierCustomer?.business_number || "-",
                    },
                    {
                      label: t("supplier contact person", {
                        ns: "myOrder",
                      }),
                      value: primarySupplierContact?.name || "-",
                    },
                    {
                      label: t("supplier phone", {
                        ns: "myOrder",
                      }),
                      value:
                        selectedSupplierCustomer?.phone ||
                        primarySupplierContact?.phone ||
                        "-",
                    },
                    {
                      label: t("supplier email", {
                        ns: "myOrder",
                      }),
                      value:
                        selectedSupplierCustomer?.email ||
                        primarySupplierContact?.email ||
                        "-",
                    },
                  ]}
                />

                <SupplierInformationColumn
                  title={t("project details", {
                    ns: "newOrder",
                  })}
                  editing={editingSection === "project"}
                  saving={savingSection}
                  onEdit={() => startSectionEditing("project")}
                  onSave={saveSectionChanges}
                  rows={[
                    {
                      label: t("city", {
                        ns: "newOrder",
                      }),
                      value:
                        editingSection === "project"
                          ? projectDraft.project_city || ""
                          : activeProject?.project_city,
                      onChange: (value) =>
                        handleProjectFieldChange("project_city", value),
                    },
                    {
                      label: t("Street", {
                        ns: "newOrder",
                      }),
                      value:
                        editingSection === "project"
                          ? projectDraft.project_address_line1 || ""
                          : activeProject?.project_address_line1,
                      onChange: (value) =>
                        handleProjectFieldChange(
                          "project_address_line1",
                          value,
                        ),
                    },
                    {
                      label: t("contact man", {
                        ns: "newOrder",
                      }),
                      value:
                        editingSection === "project"
                          ? getDraftContact(CONTACTS_ENUM.SITE_MANAGER, 0)
                              ?.full_name || ""
                          : selectedSiteManager?.full_name,
                      onChange: (value) =>
                        handleContactFieldChange(
                          CONTACTS_ENUM.SITE_MANAGER,
                          0,
                          "full_name",
                          value,
                        ),
                    },
                    {
                      label: t("phone", {
                        ns: "newOrder",
                      }),
                      value:
                        editingSection === "project"
                          ? getDraftContact(CONTACTS_ENUM.SITE_MANAGER, 0)
                              ?.phone || ""
                          : selectedSiteManager?.phone,
                      onChange: (value) =>
                        handleContactFieldChange(
                          CONTACTS_ENUM.SITE_MANAGER,
                          0,
                          "phone",
                          value,
                        ),
                      type: "tel",
                    },
                  ]}
                />

                <SupplierInformationColumn
                  title={t("Delivery details", {
                    ns: "newOrder",
                  })}
                  editing={editingSection === "delivery"}
                  saving={savingSection}
                  onEdit={() => startSectionEditing("delivery")}
                  onSave={saveSectionChanges}
                  rows={[
                    {
                      label: t("address", {
                        ns: "newOrder",
                      }),
                      value:
                        editingSection === "delivery"
                          ? projectDraft.delivery_address_line1
                          : activeProject?.delivery_address_line1,
                      onChange: (value) =>
                        handleProjectFieldChange(
                          "delivery_address_line1",
                          value,
                        ),
                    },
                    {
                      label: t("site manager", {
                        ns: "myOrder",
                      }),
                      value:
                        editingSection === "delivery"
                          ? getDraftContact(CONTACTS_ENUM.SITE_MANAGER, 0)
                              ?.full_name
                          : selectedSiteManager?.full_name,
                      onChange: (value) =>
                        handleContactFieldChange(
                          CONTACTS_ENUM.SITE_MANAGER,
                          0,
                          "full_name",
                          value,
                        ),
                    },
                    {
                      label: t("phone", {
                        ns: "newOrder",
                      }),
                      value:
                        editingSection === "delivery"
                          ? getDraftContact(CONTACTS_ENUM.SITE_MANAGER, 0)
                              ?.phone
                          : selectedSiteManager?.phone,
                      onChange: (value) =>
                        handleContactFieldChange(
                          CONTACTS_ENUM.SITE_MANAGER,
                          0,
                          "phone",
                          value,
                        ),
                    },
                    {
                      label: t("Driver notes", {
                        ns: "newOrder",
                      }),
                      value:
                        editingSection === "delivery"
                          ? projectDraft.driver_notes
                          : activeProject?.driver_notes,
                      onChange: (value) =>
                        handleProjectFieldChange("driver_notes", value),
                    },
                  ]}
                />
              </div>
            )}
          </div>
          <div className="collapse-button supplier-collapse-button">
            <button
              type="button"
              onClick={() => setShowDetails(!showDetails)}
              aria-expanded={showDetails}
              title={
                showDetails
                  ? t("collapse details", { ns: "myOrder" })
                  : t("expand details", { ns: "myOrder" })
              }
            >
              <img src={showDetails ? arrowUpIcon : arrowDownIcon} alt="" />
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="order-details-new-section">
      <div className="container p-0">
        <div className="detail-header">
          <p>{t("Order Details", { ns: "newOrder" })}</p>
          <p className="regular">
            {t("Create Date", { ns: "newOrder" })}{" "}
            {format(new Date(order.created), "dd/MM/yyyy")} |{" "}
            {t("Last update", { ns: "newOrder" })}{" "}
            {format(new Date(order.updated), "dd/MM/yyyy")} |{" "}
            {t("Order number", { ns: "newOrder" })} {order.order_no}
          </p>
        </div>
        <div className="overview">
          <div
            className={"overview-item" + (rightToLeft ? " oi-l_1" : " oi-r_1")}
            style={{ width: "359px" }}
          >
            <label>{t("Order name", { ns: "newOrder" })}</label>
            <DebounceInput
              type="text"
              debounceTimeout={1000}
              value={order.name}
              onChange={({ target }) => {
                if (!edit) {
                  localStorage.setItem("order_name", target.value);
                }
                setOrder({ ...order, name: target.value });
                if (order.name === "") {
                  setErrorText("");
                }
              }}
              placeholder={t("before typing", { ns: "newOrder" })}
            />
          </div>
          <div
            className={"overview-item" + (rightToLeft ? " oi-l_2" : " oi-r_2")}
            style={{ width: "354px" }}
          >
            <label>{t("Project Name", { ns: "newOrder" })}</label>
            {userProjects.length === 0 ? (
              <button type="button" onClick={onProjectModalOpen}>
                {t("first site", { ns: "newOrder" })}
              </button>
            ) : (
              <div className="d-flex justify-content-between align-items-center">
                <select
                  style={{
                    width: "300px",
                    backgroundImage: `url(${DropDownIcon})`,
                  }}
                  name="activeselectmobile"
                  className={rightToLeft ? "rightToLeft" : ""}
                  value={activeProject.id}
                  onChange={({ target }) =>
                    setActiveProject(
                      userProjects.find(
                        (item) => item.id === parseInt(target.value),
                      ),
                    )
                  }
                >
                  {userProjects.map((pr, index) => (
                    <option key={"pr-mob" + index} value={pr.id}>
                      {pr.name}
                    </option>
                  ))}
                </select>
                <Overlay
                  target={projAdd.current}
                  show={toolTips.ADD_NEW_PROJECT === toolTipShow}
                  placement="top"
                >
                  {(props) => (
                    <Tooltip id="overlay-example-1" {...props}>
                      {t("add new project", { ns: "newOrder" })}
                    </Tooltip>
                  )}
                </Overlay>
                <button
                  ref={projAdd}
                  className={"add-btn " + (rightToLeft ? "mr-2" : "ml-2")}
                  onClick={onProjectModalOpen}
                  onMouseEnter={() => setToolTipShow(toolTips.ADD_NEW_PROJECT)}
                  onMouseLeave={() => setToolTipShow()}
                >
                  <img src={plusIcon} alt="plus icon" />
                </button>
              </div>
            )}
          </div>
          <div
            className={"overview-item" + (rightToLeft ? " oi-l_3" : " oi-r_3")}
            style={{ width: "170px" }}
          >
            <label>{t("Delivery date", { ns: "newOrder" })}</label>
            <input
              type="date"
              value={order.delivery_date || ""}
              min={format(new Date(), "yyyy-MM-dd")}
              onChange={({ target }) => {
                setOrder({ ...order, delivery_date: target.value });
                localStorage.setItem("delivery_date", target.value);
                if (order.delivery_date === "") {
                  setErrorText("");
                }
              }}
            />
          </div>
          <div
            className="overview-item oi_4 company-overview-item"
            style={{ width: "250px" }}
          >
            <div className="company-overview-header">
              <label>{t("Company details", { ns: "newOrder" })}</label>

              {currentCompany?.id && (
                <>
                  <Overlay
                    target={companySet.current}
                    show={toolTips.COMPANY_SETTINGS === toolTipShow}
                    placement="top"
                  >
                    {(props) => (
                      <Tooltip id="company-settings-tooltip" {...props}>
                        {t("company settings", {
                          ns: "newOrder",
                        })}
                      </Tooltip>
                    )}
                  </Overlay>

                  <SettingsIcon
                    ref={companySet}
                    className="company-settings-icon"
                    onClick={handleEditBusiness}
                    onMouseEnter={() =>
                      setToolTipShow(toolTips.COMPANY_SETTINGS)
                    }
                    onMouseLeave={() => setToolTipShow()}
                  />
                </>
              )}
            </div>

            <div className="company-selection-row">
              <button
                type="button"
                className="company-selection-trigger"
                onClick={onCompanySelectionModalOpen}
              >
                <span>
                  {currentCompany?.name
                    ? currentCompany.name
                    : t("Select company", {
                        ns: "newOrder",
                        defaultValue: "בחירת חברה",
                      })}
                </span>

                <img src={DropDownIcon} alt="open company list" />
              </button>

              <button
                type="button"
                className="add-btn company-add-button"
                onClick={onNewBusinessModalOpen}
                title={t("Add new company", {
                  ns: "newOrder",
                })}
              >
                <img src={plusIcon} alt="plus icon" />
              </button>
            </div>
          </div>
        </div>
        {showDetails && (
          <div className="details">
            <div className="detail-section">
              <div className="detail-item title">
                <p className="label bold-text title">
                  {t("Order creator", { ns: "newOrder" })}
                </p>
                <Overlay
                  target={userSet.current}
                  show={toolTips.USER_SETTINGS === toolTipShow}
                  placement="top"
                >
                  {(props) => (
                    <Tooltip id="overlay-example-1" {...props}>
                      {t("user settings", { ns: "newOrder" })}
                    </Tooltip>
                  )}
                </Overlay>
                <SettingsIcon
                  ref={userSet}
                  style={{ cursor: "pointer" }}
                  onClick={() => router.push("/view-profile")}
                  onMouseEnter={() => setToolTipShow(toolTips.USER_SETTINGS)}
                  onMouseLeave={() => setToolTipShow()}
                />
              </div>
              <div className="detail-item">
                <p className="label">{t("Full name", { ns: "newOrder" })}</p>
                <p className="value bold-text text-uppercase">
                  {userData.first_name + " " + userData.last_name}
                </p>
              </div>
              <div className="detail-item">
                <p className="label">{t("Job title", { ns: "newOrder" })}</p>
                <p className="value">{userData.job_title || "-"}</p>
              </div>
              <div className="detail-item">
                <p className="label">{t("phone", { ns: "newOrder" })}</p>
                <p className="value">{userData.phone || "-"}</p>
              </div>
              <div className="detail-item">
                <p className="label">{t("email", { ns: "newOrder" })}</p>
                <p className="value">{userData.email || "-"}</p>
              </div>
            </div>
            <div className="detail-section">
              <div className="detail-item title">
                <p className="label bold-text title">
                  {t("project details", { ns: "newOrder" })}
                </p>

                {editingSection === "project" ? (
                  <button
                    type="button"
                    className="inline-save-button"
                    onClick={saveSectionChanges}
                    disabled={savingSection}
                    title={t("Save", { ns: "common" })}
                  >
                    {savingSection ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      "✓"
                    )}
                  </button>
                ) : (
                  Object.keys(activeProject).length > 0 && (
                    <>
                      <Overlay
                        target={edit1.current}
                        show={toolTips.EDIT_PROJECT === toolTipShow}
                        placement="top"
                      >
                        {(props) => (
                          <Tooltip id="project-edit-tooltip" {...props}>
                            {t("edit", { ns: "common" })}
                          </Tooltip>
                        )}
                      </Overlay>

                      <EditIcon
                        ref={edit1}
                        className="icon-btn"
                        onClick={() => startSectionEditing("project")}
                        onMouseEnter={() =>
                          setToolTipShow(toolTips.EDIT_PROJECT)
                        }
                        onMouseLeave={() => setToolTipShow()}
                      />
                    </>
                  )
                )}
              </div>

              <div className="detail-item">
                <p className="label">{t("city", { ns: "newOrder" })}</p>

                {editingSection === "project" ? (
                  <input
                    className="inline-detail-input"
                    type="text"
                    value={projectDraft.project_city || ""}
                    onChange={(event) =>
                      handleProjectFieldChange(
                        "project_city",
                        event.target.value,
                      )
                    }
                  />
                ) : (
                  <p className="value">{activeProject.project_city || "-"}</p>
                )}
              </div>

              <div className="detail-item">
                <p className="label">{t("Street", { ns: "newOrder" })}</p>

                {editingSection === "project" ? (
                  <input
                    className="inline-detail-input"
                    type="text"
                    value={projectDraft.project_address_line1 || ""}
                    onChange={(event) =>
                      handleProjectFieldChange(
                        "project_address_line1",
                        event.target.value,
                      )
                    }
                  />
                ) : (
                  <p className="value">
                    {activeProject.project_address_line1 || "-"}
                  </p>
                )}
              </div>

              <div className="detail-item">
                <p className="label">{t("site man", { ns: "newOrder" })}</p>

                {editingSection === "project" ? (
                  <input
                    className="inline-detail-input"
                    type="text"
                    value={
                      getDraftContact(CONTACTS_ENUM.SITE_MANAGER)?.full_name ||
                      ""
                    }
                    onChange={(event) =>
                      handleContactFieldChange(
                        CONTACTS_ENUM.SITE_MANAGER,
                        0,
                        "full_name",
                        event.target.value,
                      )
                    }
                  />
                ) : (
                  <p className="value">{siteManager?.full_name || "-"}</p>
                )}
              </div>

              <div className="detail-item">
                <p className="label">{t("phone", { ns: "newOrder" })}</p>

                {editingSection === "project" ? (
                  <input
                    className="inline-detail-input"
                    type="tel"
                    value={
                      getDraftContact(CONTACTS_ENUM.SITE_MANAGER)?.phone || ""
                    }
                    onChange={(event) =>
                      handleContactFieldChange(
                        CONTACTS_ENUM.SITE_MANAGER,
                        0,
                        "phone",
                        event.target.value,
                      )
                    }
                  />
                ) : (
                  <p className="value">{siteManager?.phone || "-"}</p>
                )}
              </div>
            </div>
            <div className="detail-section">
              <div className="detail-item title">
                <p className="label bold-text title">
                  {t("Delivery details", { ns: "newOrder" })}
                </p>

                {editingSection === "delivery" ? (
                  <button
                    type="button"
                    className="inline-save-button"
                    onClick={saveSectionChanges}
                    disabled={savingSection}
                    title={t("Save", { ns: "common" })}
                  >
                    {savingSection ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      "✓"
                    )}
                  </button>
                ) : (
                  !editingSection &&
                  Object.keys(activeProject).length > 0 && (
                    <>
                      <Overlay
                        target={edit2.current}
                        show={toolTips.EDIT_PROJECT1 === toolTipShow}
                        placement="top"
                      >
                        {(props) => (
                          <Tooltip id="delivery-edit-tooltip" {...props}>
                            {t("edit", { ns: "common" })}
                          </Tooltip>
                        )}
                      </Overlay>

                      <EditIcon
                        ref={edit2}
                        className="icon-btn"
                        onClick={() => startSectionEditing("delivery")}
                        onMouseEnter={() =>
                          setToolTipShow(toolTips.EDIT_PROJECT1)
                        }
                        onMouseLeave={() => setToolTipShow()}
                      />
                    </>
                  )
                )}
              </div>

              <div className="detail-item">
                <p className="label">{t("address", { ns: "newOrder" })}</p>

                {editingSection === "delivery" ? (
                  <input
                    className="inline-detail-input"
                    type="text"
                    value={projectDraft.delivery_address_line1 || ""}
                    onChange={(event) =>
                      handleProjectFieldChange(
                        "delivery_address_line1",
                        event.target.value,
                      )
                    }
                  />
                ) : (
                  <p className="value">
                    {activeProject.delivery_address_line1 || "-"}
                  </p>
                )}
              </div>

              <div className="detail-item">
                <p className="label">{t("contact man", { ns: "newOrder" })}</p>

                {editingSection === "delivery" ? (
                  <div className="inline-contact-inputs">
                    <input
                      className="inline-detail-input"
                      type="text"
                      placeholder={t("Full name", { ns: "newOrder" })}
                      value={
                        getDraftContact(CONTACTS_ENUM.SITE_MAN, 0)?.full_name ||
                        ""
                      }
                      onChange={(event) =>
                        handleContactFieldChange(
                          CONTACTS_ENUM.SITE_MAN,
                          0,
                          "full_name",
                          event.target.value,
                        )
                      }
                    />

                    <input
                      className="inline-detail-input"
                      type="tel"
                      placeholder={t("phone", { ns: "newOrder" })}
                      value={
                        getDraftContact(CONTACTS_ENUM.SITE_MAN, 0)?.phone || ""
                      }
                      onChange={(event) =>
                        handleContactFieldChange(
                          CONTACTS_ENUM.SITE_MAN,
                          0,
                          "phone",
                          event.target.value,
                        )
                      }
                    />
                  </div>
                ) : (
                  <p className="value">{siteMans.siteMan1 || "-"}</p>
                )}
              </div>

              <div className="detail-item">
                <p className="label">{t("contact man", { ns: "newOrder" })}</p>

                {editingSection === "delivery" ? (
                  <div className="inline-contact-inputs">
                    <input
                      className="inline-detail-input"
                      type="text"
                      placeholder={t("Full name", { ns: "newOrder" })}
                      value={
                        getDraftContact(CONTACTS_ENUM.SITE_MAN, 1)?.full_name ||
                        ""
                      }
                      onChange={(event) =>
                        handleContactFieldChange(
                          CONTACTS_ENUM.SITE_MAN,
                          1,
                          "full_name",
                          event.target.value,
                        )
                      }
                    />

                    <input
                      className="inline-detail-input"
                      type="tel"
                      placeholder={t("phone", { ns: "newOrder" })}
                      value={
                        getDraftContact(CONTACTS_ENUM.SITE_MAN, 1)?.phone || ""
                      }
                      onChange={(event) =>
                        handleContactFieldChange(
                          CONTACTS_ENUM.SITE_MAN,
                          1,
                          "phone",
                          event.target.value,
                        )
                      }
                    />
                  </div>
                ) : (
                  <p className="value">{siteMans.siteMan2 || "-"}</p>
                )}
              </div>

              <div className="detail-item">
                <p className="label">{t("Driver notes", { ns: "newOrder" })}</p>

                {editingSection === "delivery" ? (
                  <input
                    className="inline-detail-input"
                    type="text"
                    value={projectDraft.driver_notes || ""}
                    onChange={(event) =>
                      handleProjectFieldChange(
                        "driver_notes",
                        event.target.value,
                      )
                    }
                  />
                ) : (
                  <p className="value">{activeProject.driver_notes || "-"}</p>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="collapse-button">
          <button onClick={() => setShowDetails(!showDetails)}>
            <img src={showDetails ? arrowUpIcon : arrowDownIcon} alt="down" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default OrderDetails;
